"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longStatusMessages = exports.shortStatusMessages = void 0;
const patientCondition_1 = require("../../forms/basic-health/patientCondition");
exports.shortStatusMessages = {
    [patientCondition_1.Status.NEW]: {
        id: "patient_status.short.new",
        defaultMessage: "ÚJ"
    },
    [patientCondition_1.Status.MEDICAL_EXAMINATION_IN_PROGRESS]: {
        id: "patient_status.short.medical_examination_in_progress",
        defaultMessage: "EIP"
    },
    [patientCondition_1.Status.DONE]: {
        id: "patient_status.short.done",
        defaultMessage: "D"
    },
    [patientCondition_1.Status.EXIT]: {
        id: "patient_status.short.exit",
        defaultMessage: "EX"
    }
};
exports.longStatusMessages = {
    [patientCondition_1.Status.NEW]: {
        id: "patient_status.long.new",
        defaultMessage: "Új"
    },
    [patientCondition_1.Status.MEDICAL_EXAMINATION_IN_PROGRESS]: {
        id: "patient_status.long.medical_examination_in_progress",
        defaultMessage: "Kivizsgálás folyamatban"
    },
    [patientCondition_1.Status.DONE]: {
        id: "patient_status.long.done",
        defaultMessage: "Kivizsgálás megtörtént"
    },
    [patientCondition_1.Status.EXIT]: {
        id: "patient_status.long.exit",
        defaultMessage: "Exit"
    }
};
